import React from 'react';
import styled from 'styled-components'
import { media } from '../utilities/styled'
import LanguageSwitcher from '../language-switcher'


const StyledLink = styled.div`
  margin-top:5px;
  display: flex;
`
const StyledTextLink = styled.div`
  font-family: elsevier-sans;
  font-size:20px;
  margin-right:10px;
  margin-left:10px;  
  cursor: pointer;
`
const StyledTextTitle = styled.div`
  font-family: elsevier-sans;
  font-size:20px;
  margin-left:10px;
  visibility: visible;
  @media (max-width: 1400px) {
    visibility: hidden;   
    display:none;   
  }  
`

const OuterContainer = styled.div`
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  position: absolute;
  right: 0;
  margin: 32px auto 0;
  z-index: 8888889;
  padding: 16px;
  border-top: 2px solid #ff6c00;
  background: rgba(235, 235, 235, 0.85);
  max-width: calc(100vw - 32px);
  

  &:before {
    position: absolute;
    top: -13px;
    right: 0;
    content: ' ';
    width: 0;
    height: 0;
    border-top: 6.5px solid transparent;
    border-left: 6.5px solid transparent;
    border-right: 6.5px solid #ff6c00;
    border-bottom: 6.5px solid #ff6c00;
  }
`

const InnerContainer = styled.div`
  background: white;
  padding: 16px;
  max-width: 100%;
  text-align: left;
  white-space: nowrap;

  &:after {
    position: absolute;
    right: 0;
    content: ' ';
    width: 0;
    height: 0;
    border-top: 6.5px solid transparent;
    border-left: 6.5px solid transparent;
    top: -10px;
    border-right: 6.5px solid #ebebeb;
    border-bottom: 6.5px solid #ebebeb;
  }
`

const IconSVG = styled.div`
  
`

class LanguageMenu extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
        }
    }

    render() {
    const { visible } = this.state
    const { title, languageSelect } = this.props

    return (
      <StyledLink
        // onMouseEnter={() => this.setState({ visible: true })}
        // onMouseLeave={() => this.setState({ visible: false })}
        onClick={() => this.setState({ visible: (!visible) })}
      >
        <IconSVG>
          <svg
            focusable="false"
            role="img"
            viewBox="0 0 106 128"
            width="19.875"
            height="24"
            className="gh-icon icon-globe"
          >
            <path
              d="M51.964 114h.008c44.946 0 68.276-54.748 36.034-86.988-17.04-17.042-38.51-14.928-36.04-14.928h-.002c-13.604 0-26.404 5.28-36.036 14.91C6.3 36.62 1 49.422 1 63.034.998 91.194 23.794 114 51.964 114zM11.328 67.998h17.758c.434 9.992 2.406 23.254 7.02 32.83C23.134 95.384 13.168 83.984 11.328 68zM43.9 93.708c-2.718-6.944-4.38-15.72-4.806-25.71h25.744C63.828 91.978 56.266 104 51.968 104c-3.39 0-6.83-7.13-8.068-10.294zm23.926 7.122c4.612-9.576 6.586-22.84 7.02-32.832H92.6c-1.84 15.986-11.818 27.394-24.776 32.832zm.018-75.562l-.02-.04c9.49 3.978 17.544 11.814 21.75 21.54-.02 0-.04.012-.058.01a39.756 39.756 0 0 1 3.086 11.268H74.846c-.308-7.994-1.326-14.864-2.96-21.274a32.756 32.756 0 0 0-12.472-5.86c3.534 8.132 5.036 19.14 5.424 27.134H39.094c1.016-23.98 8.62-35.98 12.872-35.982 4.25-.004 10.806 1.068 15.878 3.204zm-31.74-.012c-4.612 9.574-6.584 22.798-7.02 32.79H11.328c1.844-15.988 11.824-27.354 24.778-32.79z"
              fill="#53565A"
            />
          </svg>
        </IconSVG> 
          <StyledTextTitle> {title}  | </StyledTextTitle>          
          <StyledTextLink> {languageSelect} </StyledTextLink>
        <IconSVG>
        <svg
          width="18"
          height="11"
          viewBox="0 0 18 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.256836 2.30078L1.56934 0.988281L8.69434 8.11328L15.8193 0.988281L17.1318 2.30078L8.69434 10.7383L0.256836 2.30078Z"
            fill="#2E2E2E"
          />
        </svg>
        </IconSVG>
        <OuterContainer
          visible={visible}
          onMouseLeave={() => this.setState({ visible: false })}
        >
          <InnerContainer>
            <LanguageSwitcher />
          </InnerContainer>
        </OuterContainer>
      </StyledLink>
    )
  }
}

export default LanguageMenu
